import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProcessingHero from './components/ProcessingHero';
import ProcessingServices from './components/ProcessingServices';
import ProcessingWorkflow from './components/ProcessingWorkflow';
import ProcessingStandards from './components/ProcessingStandards';
import ProcessingIntegration from './components/ProcessingIntegration';
import ProcessingCTABand from './components/ProcessingCTABand';

export default function ProcessingPage() {
  return (
    <>
      <Navbar />
      <main>
        <ProcessingHero />
        <ProcessingServices />
        <ProcessingWorkflow />
        <ProcessingStandards />
        <ProcessingIntegration />
        <ProcessingCTABand />
      </main>
      <Footer />
    </>
  );
}